import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch("https://xebrand.in/Backend/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        localStorage.setItem("authToken", result.token); // Save JWT token in localStorage
        navigate("/dashboard"); // Redirect to dashboard
      } else {
        setError(result.message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h2 className="text-xl font-bold mb-4">Login</h2>
      <form onSubmit={handleLogin} className="w-full max-w-sm">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          className="border rounded px-4 py-2 w-full mb-2"
          placeholder="Enter your email"
          required
        />
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          className="border rounded px-4 py-2 w-full mb-4"
          placeholder="Enter your password"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className={`px-4 py-2 rounded w-full ${
            loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 text-white"
          }`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      {error && <p className="text-red-500 mt-4">{error}</p>}
      {/* <p className="mt-4">
        Don't have an account?{" "}
        <Link to="/signup" className="text-blue-500 underline">
          Sign Up
        </Link>
      </p> */}
    </div>
  );
};

export default Login;
